// extracted by mini-css-extract-plugin
export default {"gridContainer":"Portfolio_gridContainer__XSFQt","imageWrapper":"Portfolio_imageWrapper__dJnRK","image":"Portfolio_image__LC98N"};